import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { UrlInput } from '@/Domain/components/KnowledgeBase/UploadUrlModal/components/UrlInput';
import { Button } from '@/Domain/components/Shared/Button/Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/Domain/components/Shared/Dialog/Dialog';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/Domain/components/Shared/Form/Form';
import { Separator } from '@/Domain/components/Shared/Separator/Separator';
import { WebsiteModalTypeEnum } from '@/Domain/enum/WebsiteModalType.enum';
import { useShopifyMcpActionForm } from '@/Domain/hooks/Action/ShopifyMcp/useShopifyMcpActionForm.hook';
import { MODAL_NAMES, useModalStore } from '@/Domain/store/modal.store';

export const ShopifyMcpActionDialog = () => {
  const { t } = useTranslation('shopify_mcp');
  const { isOpen, closeModal, params } = useModalStore();

  const { shopifyMcpAction } = params || {};
  const { form, handleSubmit, onInvalid } = useShopifyMcpActionForm(shopifyMcpAction);

  useEffect(() => {
    if (!shopifyMcpAction) return;
  }, [shopifyMcpAction]);

  return (
    <div data-testid="shopify-mcp-action-dialog">
      <Dialog open={isOpen(MODAL_NAMES.SHOPIFY_MCP_DIALOG)} onOpenChange={closeModal}>
        <DialogContent className="w-lg">
          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(handleSubmit, onInvalid)}
              autoComplete="off"
              className="space-y-4"
            >
              <DialogHeader>
                <DialogTitle>{t('title')}</DialogTitle>
                <DialogDescription>{t('description')}</DialogDescription>
              </DialogHeader>
              <FormField
                name="shopify_url"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>{t('form.shopify_url_label')}</FormLabel>
                    <FormControl>
                      <div data-testid="shopify-mcp-action-form-url">
                        <UrlInput type={WebsiteModalTypeEnum.SINGLE} {...field} />
                      </div>
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <Separator />
              <DialogFooter className="flex flex-row !justify-end items-center">
                <div className="flex gap-2">
                  <Button variant="secondary" onClick={closeModal} type="button">
                    {t('button.cancel')}
                  </Button>

                  <Button
                    variant="dark"
                    type="submit"
                    data-testid="shopify-mcp-action-sheet-submit-button"
                  >
                    {t('button.save')}
                  </Button>
                </div>
              </DialogFooter>
            </form>
          </Form>
        </DialogContent>
      </Dialog>
    </div>
  );
};
